/***
 * Excerpted from "Craft GraphQL APIs in Elixir with Absinthe",
 * published by The Pragmatic Bookshelf.
 * Copyrights apply to this code. It may not be used to create training material,
 * courses, books, articles, and the like. Contact us if you are in doubt.
 * We make no guarantees that this code is fit for any purpose.
 * Visit http://www.pragmaticprogrammer.com/titles/wwgraphql for more book information.
***/
import ApolloClient from "apollo-client";
import { ApolloLink } from "apollo-link";
import { HttpLink } from "apollo-link-http";
import { onError } from "apollo-link-error";
import {hasSubscription} from "@jumpn/utils-graphql";
import { InMemoryCache as Cache, defaultDataIdFromObject } from "apollo-cache-inmemory";
import absintheSocketLink from "./absinthe-socket-link";
import { setContext } from 'apollo-link-context';
import {GRAPHQL_ENDPOINT} from "../config";
import {fromJS} from "immutable";
import {logout} from "../lib/api/AuthApi";

const splitLink = new ApolloLink.split(
  (operation) => hasSubscription(operation.query),
  absintheSocketLink,
  new HttpLink({
    mode: "cors",
    uri: GRAPHQL_ENDPOINT
  })
)

const authLink = setContext((_, {headers}) => {
  // auth token.
  const token = localStorage.getItem("access_token");
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ""
    }
  }
})

const logoutLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    let unauthorizedError = fromJS(graphQLErrors).find((x) => {
      return x.get("message") === "unauthorized";
    })
    if (unauthorizedError) {
      logout();
      return;
    }
  }
  if (networkError && networkError.statusCode === 401) logout();
})


const link = logoutLink.concat(authLink).concat(splitLink);

export default new ApolloClient({
  link: link,
  // addTypename: true,
  cache: new Cache({
    dataIdFromObject: object => {
      switch (object.__typename.toLowerCase()) {
        case "product": return object.sku;
        case "shopproduct": return `${object.shopId}:${object.productSku}`;
        case "shopsubscriptionproduct": return `${object.shopId}:${object.productSku}:${object.version}`;
        case "waterpallet": return object.palletId;
        case "pallet": return object.palletId;
        case "shippingorder": return `shipping-order:${object.orderId}`;
        case "salesorder": return `sales-order:${object.orderId}`;
        case "subscriptiondelivery": return `subscription-delivery:${object.deliveryId}`;
        case "shippingordersactionsview": return `actions-view:${object.orderId}`;
        case "infrastructureserviceping": return `infra-service-ping:${object.serviceId}`;
        case "note": return `note:${object.noteId}`;
        default: return defaultDataIdFromObject(object);
      }
    }
  })
});
